// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as InfoCircleDefault } from '../../../assets/icons/default/general/info-circle.svg?react';
import { ReactComponent as InfoCircleSolid } from '../../../assets/icons/solid/general/INFO-CIRCLE.svg?react';
import { createIcons } from '../../Icon';
const InfoCircleIcon = /* @__PURE__ */ createIcons('InfoCircle', {
    default: InfoCircleDefault,
    solid: InfoCircleSolid
});
InfoCircleIcon.supportedTypes = ['default', 'solid'];
InfoCircleIcon.category = 'general';
export default InfoCircleIcon;
